/* CHAOS Coat Edit — AJAX cart progress synchronizer.
   Reads the live Shopify cart JSON after changes; doesn't modify checkout or pricing. */
(function () {
  'use strict';
  if (window.__chaosCoatCartGuideV2) return;
  window.__chaosCoatCartGuideV2 = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  root = root.replace(/\/?$/, '/');
  var endpoint = root + 'cart.js';
  var timer = null, fetching = false, again = false;
  var status = [
    'Add a second coat to save 20% on that coat. Add a third for 30% off both extras.',
    'Add one more coat to save 20% on the lower-priced coat.',
    '20% off your second coat unlocked! Add one more coat to get 30% off the two lower-priced coats.',
    '30% off your second and third coats unlocked! The savings apply to the two lower-priced coats.'
  ];

  function qualifyingCount(cart) {
    if (!cart || !Array.isArray(cart.items)) return 0;
    return cart.items.reduce(function (count, item) {
      var name = String(item.product_title || item.title || '').toLowerCase();
      var handle = String(item.handle || '').toLowerCase();
      return count + ((name.indexOf('coat') !== -1 && handle !== 'coat-cover') ? (Number(item.quantity) || 0) : 0);
    }, 0);
  }

  function setText(el, value) {
    if (el && el.textContent !== value) el.textContent = value;
  }

  var lastCoatCount = null, toastNode = null, toastTimer = null;
  var celebrated = Object.create(null);
  var milestones = {
    1: {title:'Lovely choice! First coat added.',message:'Add one more coat to get 20% off the lower-priced one.',cta:'CHOOSE YOUR SECOND COAT',toast:'Your first coat is in! ✦'},
    2: {title:'Beautiful! You’ve unlocked 20%.',message:'Add one more coat to unlock 30% off both extras.',cta:'UNLOCK 30% OFF',toast:'20% off unlocked! ✦'},
    3: {title:'You did it! Top reward unlocked.',message:'Your two lower-priced coats get 30% off each.',cta:'REVIEW YOUR CART',toast:'30% off unlocked! ✦'}
  };
  function dismissToast() {
    if(toastTimer!==null){window.clearTimeout(toastTimer);toastTimer=null;}
    if(toastNode&&toastNode.parentNode)toastNode.parentNode.removeChild(toastNode);
    toastNode=null;
  }
  function el(tag,cls,txt) {
    var e=document.createElement(tag);e.className=cls;
    if(txt!==undefined)e.textContent=txt;
    return e;
  }
  function showReward(stage) {
    if(!milestones[stage]||celebrated[stage]||!document.body)return;
    celebrated[stage]=true;dismissToast();
    var data=milestones[stage],toast=el('aside','chaos-coat-celebrate');
    toast.setAttribute('role','status');toast.setAttribute('aria-live','polite');
    var close=el('button','chaos-coat-celebrate__close','×');
    close.type='button';close.setAttribute('aria-label','Dismiss reward');close.addEventListener('click',dismissToast);
    toast.appendChild(close);
    toast.appendChild(el('p','chaos-coat-celebrate__eyebrow','✦ CHAOS COAT REWARDS ✦'));
    toast.appendChild(el('h3','chaos-coat-celebrate__heading',data.toast));
    toast.appendChild(el('p','chaos-coat-celebrate__copy',data.message));
    var link=el('a','chaos-coat-celebrate__link',data.cta);
    link.href=root+(stage>=3?'cart':'collections/chaos-coat-edit-bundle');
    link.addEventListener('click',dismissToast);
    toast.appendChild(link);document.body.appendChild(toast);toastNode=toast;
    toastTimer=window.setTimeout(dismissToast,8500);
  }
  function updateMilestone(guide,count) {
    var p=guide.querySelector('[data-chaos-milestone]');if(!p)return;
    var stage=Math.min(count,3),data=milestones[stage];
    p.hidden=!data;
    if(!data){p.setAttribute('data-chaos-stage','0');return;}
    var prev=p.getAttribute('data-chaos-stage');
    p.setAttribute('data-chaos-stage',String(stage));
    setText(p.querySelector('[data-chaos-milestone-title]'),data.title);
    setText(p.querySelector('[data-chaos-milestone-description]'),data.message);
    var link=p.querySelector('[data-chaos-milestone-link]');
    if(link){setText(link,data.cta+(stage<3?' →':''));link.href=root+(stage>=3?'cart':'collections/chaos-coat-edit-bundle');}
    if(prev!==String(stage)){
      p.classList.remove('chaos-cart-bundle__milestone--animate');
      void p.offsetWidth;
      p.classList.add('chaos-cart-bundle__milestone--animate');
    }
  }

  function paint(cart) {
    var count = qualifyingCount(cart);
    var progress = Math.min(count, 3);
    var message = status[progress];
    var label = progress + ' of 3 coats added';
    if (progress === 3) label += ' — 30% tier unlocked';
    document.querySelectorAll('[data-chaos-cart-guide]').forEach(function (guide) {
      guide.setAttribute('data-chaos-coat-count', String(count));
      setText(guide.querySelector('[data-chaos-cart-status]'), message);
      setText(guide.querySelector('[data-chaos-cart-count]'), label);
      var bar = guide.querySelector('[data-chaos-cart-progress]');
      if (bar) bar.setAttribute('aria-valuenow', String(progress));
      var fill = guide.querySelector('[data-chaos-cart-progress-fill]');
      if (fill) fill.style.width = (progress * 100 / 3) + '%';
      updateMilestone(guide,count);
    });
    if (lastCoatCount !== null) {
      if (count > lastCoatCount) showReward(progress);
      else if (count < lastCoatCount) dismissToast();
    }
    if (lastCoatCount === null) {
      try {
        if (window.sessionStorage.getItem('chaos_coat_reward_pending') === '1' && count > 0) {
          window.sessionStorage.removeItem('chaos_coat_reward_pending');
          showReward(progress);
        }
      } catch (err) {}
    }
    lastCoatCount = count;
    document.dispatchEvent(new CustomEvent('chaos:cart:synced', { detail: { cart: cart } }));
  }

  function refresh() {
    if (fetching) { again = true; return; }
    fetching = true;
    window.fetch(endpoint, {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { 'Accept': 'application/json' }
    }).then(function (r) {
      if (!r.ok) throw new Error('Cart HTTP ' + r.status);
      return r.json();
    }).then(paint).catch(function () {
      /* Keep the Shopify-rendered cart guide if the cart request fails. */
    }).then(function () {
      fetching = false;
      if (again) { again = false; schedule(120); }
    });
  }

  function schedule(delay) {
    if (timer) window.clearTimeout(timer);
    timer = window.setTimeout(function () {
      timer = null;
      refresh();
    }, delay == null ? 140 : delay);
  }

  function isRelevantMutation(record) {
    if (record.type !== 'childList') return false;
    var t = record.target;
    if (t && t.nodeType === 1 && t.closest && t.closest('[data-chaos-cart-guide]')) return false;
    if (t && t.nodeType === 1 && t.closest && t.closest('[data-cart-items], [data-cart-content], [data-cart-prices]')) return true;
    var nodes = record.addedNodes;
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      if (n.nodeType !== 1) continue;
      if (n.matches && n.matches('[data-chaos-cart-guide], [data-cart-items], [data-cart-wrapper], [data-cart-content]')) return true;
      if (n.querySelector && n.querySelector('[data-chaos-cart-guide], [data-cart-items], [data-cart-wrapper]')) return true;
    }
    return false;
  }

  function monitor() {
    if (!document.body) return;
    var observer = new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        if (isRelevantMutation(records[i])) { schedule(175); break; }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
    schedule(60);
  }

  /* Refresh after product page add-to-cart as well as drawer edits. */
  document.addEventListener('click',function(event){
    var target=event.target;
    if(target&&target.closest&&target.closest('button[name="add"],[data-action-atc],[data-action="add-to-cart"],.t4s-pr-addtocart,.t4s-product-form__submit')){
      schedule(800);
    }
  },true);
  window.addEventListener('pageshow',function(e){if(e.persisted)schedule(80);});
  /* Secondary signals for controls that AJAX-render without replacing cart markup. */
  document.addEventListener('change', function (event) {
    var t = event.target;
    if (t && t.closest && t.closest('[data-cart-wrapper], [data-cart-content], #t4s-mini_cart')) schedule(650);
  }, true);
  document.addEventListener('click', function (event) {
    var t = event.target;
    if (!t || !t.closest) return;
    if (t.closest('[data-cart-wrapper], [data-cart-content], #t4s-mini_cart') &&
        t.closest('button, a[data-cart-remove], [data-cart-change], [data-quantity], [data-cart-item]')) {
      schedule(850);
    }
  }, true);

  ['cart:updated', 'cart:refresh', 'cart:change', 't4s:cart:updated', 't4s:cart:update'].forEach(function (name) {
    document.addEventListener(name, function () { schedule(100); });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', monitor);
  else monitor();
}());
